import React from "react";
import { Outlet } from "react-router-dom";

import ErrorBoundary from "./Components/ErrorBoundry/ErrorBoundry";
import FallbackComponent from "./Components/ErrorBoundry/FallbackComponent";
import Navbar from "./Components/Navbar/Navbar";
import ReportButton from "./Components/ReportButton/ReportButton";

import "./App.css";

function App() {
	return (
		<div className="App">
			<ErrorBoundary fallback={<FallbackComponent />}>
				<Navbar>
					<Outlet />
				</Navbar>
				<ReportButton />
			</ErrorBoundary>
		</div>
	);
}

export default App;
